import { Component, Input } from '@angular/core';
import { Observable, map, timer } from 'rxjs';
import { AsyncPipe } from '@angular/common';

const dateFormatter = new Intl.DateTimeFormat('en-US', {
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric',
});

const timeFormatter = new Intl.DateTimeFormat('en-US', {
  hour: 'numeric',
  minute: '2-digit',
  hour12: true,
});

const formatCurrentDate = (date: Date): string => `${dateFormatter.format(date)} ${timeFormatter.format(date)}`;

@Component({
  selector: 'app-status-summary',
  templateUrl: './status-summary.component.html',
  styleUrls: ['./status-summary.component.scss'],
  imports: [AsyncPipe],
})
export class StatusSummaryComponent {
  @Input() available = 0;
  @Input() notAvailable = 0;
  @Input() outOfOffice = 0;

  readonly currentDate$: Observable<string> = timer(0, 1000).pipe(map(() => formatCurrentDate(new Date())));
}
